import React from 'react'

export default function InfluencerSignupSuccess() {
  return (
    <div className="flex flex-col min-h-screen w-screen items-center justify-center">
      <h1 className="text-2xl font-bold uppercase">Vielen Dank für die Einreichung deines Profils!</h1>
      <p>Wir melden uns bei dir, wenn es passende Kampagnen für dich gibt.</p>
      <a href="https://www.reachbird.io/de/" className="mt-1 px-2 py-1 bg-rb-green text-white rounded-md">Back to site</a>
    </div>
  )
}